module.exports = __webpack_public_path__ + "static/media/ico_cnf_ext-08.b30c1c22.svg";